import { useCallback } from 'react';
import apiClient from 'src/api/axiosClient';
import {
  ExportMessageErrorReportsApiParams,
  ExportMessageErrorReportsParams,
  GetMessageErrorReportsApiParams,
  GetMessageErrorReportsParams,
  GetMessageErrorSummaryReportsParams,
  GetMessageErrorSummaryReportsApiParams,
} from './types';

export function useGetMessageErrorReportsApi(): GetMessageErrorReportsApiParams {
  return useCallback(
    (params: GetMessageErrorReportsParams) => apiClient.get('/reports/message-errors', { 
      params: {
        startDateInterval: params.startDateInterval.format('YYYY-MM-DD'),
        endDateInterval: params.endDateInterval.add(1, 'day').format('YYYY-MM-DD'),
        query: params.query,
        applicationId: params.applicationId,
        companyId: params.companyId,
        sort: params.sort,
        groupBy: params.groupBy,
      },
    }),
    [apiClient],
  );
}

export function useGetMessageErrorSummaryReportsApi(): GetMessageErrorSummaryReportsApiParams {
  return useCallback(
    (params: GetMessageErrorSummaryReportsParams) =>
      apiClient.get('/reports/message-errors-summary', { 
        params: {
          startDateInterval: params.startDateInterval.format('YYYY-MM-DD'),
          endDateInterval: params.endDateInterval.add(1, 'day').format('YYYY-MM-DD'),
        },
      }),
    [],
  );
}

export function useExportMessageErrorReportsApi(): ExportMessageErrorReportsApiParams {
  return useCallback(
    (params: ExportMessageErrorReportsParams) =>
      apiClient.get('/reports/message-errors/export', {
        params: {
          startDateInterval: params.startDateInterval.format('YYYY-MM-DD'),
          endDateInterval: params.endDateInterval.add(1, 'day').format('YYYY-MM-DD'),
          applicationId: params.applicationId,
          companyId: params.companyId,
          errorCodes: params.errorCodes?.join(','),
        },
        responseType: 'blob',
      }),
    [apiClient],
  );
}

export function useReportsApi() {
  const getMessageErrorReports = useGetMessageErrorReportsApi();
  const getMessageErrorSummaryReports = useGetMessageErrorSummaryReportsApi();
  const exportMessageErrorReports = useExportMessageErrorReportsApi();

  return {
    getMessageErrorReports,
    getMessageErrorSummaryReports,
    exportMessageErrorReports,
  };
}
